import React from 'react';
// components
import { Route } from 'react-router-dom';
import MainLayout from '../MainLayout';

const PublicRoute = ({
  component: Component,
  background,
  blobs = false,
  ...routeProps
}) => (
  <Route
    {...routeProps}
    render={matchProps => (
      <MainLayout background={background} blobs={blobs}>
        <Component {...matchProps} />
      </MainLayout>
    )}
  />
);

export default PublicRoute;



// WEBPACK FOOTER //
// ./src/layouts/routes/PublicRoute.jsx